import React, { useState } from "react";
import Modal from "../../Common/Modal";
import MtiButton from "../../Buttons/MtiButton";
import "./FindSafePositionModalProgress.css";
import { ESuiteModeState } from "../../../Model/ModuleState";
import RollerLoadingAnimation from "../Storage/StorageCalibration/AutoCalibration/RollerLoadingAnimation";

type Props = {
  show: boolean;
  onHide: () => void;
  stopFinding: () => void;
  findSafePositionState: ESuiteModeState;
};

export default function FindSafePositionModalProgress({
  show,
  onHide,
  stopFinding,
  findSafePositionState,
}: Props) {
  const [doFadeOut, setDoFateOut] = useState(false);

  const onClickTerminate = () => {
    if (findSafePositionState !== ESuiteModeState.Stopping) {
      stopFinding();
    }
  };

  return (
    <Modal
      show={show}
      onHide={onHide}
      hideOnBackdropClick={false}
      className={
        doFadeOut
          ? "auto-calibration-progress-modal calibrating-done"
          : "auto-calibration-progress-modal"
      }
    >
      <Modal.Header
        title={"Find Safe Position"}
        hideButtonEnabled={false}
        className="auto-calibration-progress-header"
      />
      <Modal.Body className="auto-calibration-progress-body">
        <RollerLoadingAnimation />
        <div className="progress-title">
          {findSafePositionState !== ESuiteModeState.Stopping ? (
            <div>
              <div className="title-body">Finding safe position...</div>
              <div className="progress-subtittle">Please wait until the process completes.</div>
            </div>
          ) : (
            <p>Find Safe position is being canceled</p>
          )}
        </div>
        {findSafePositionState !== ESuiteModeState.Stopping ? (
          <MtiButton
            colorVariant="error"
            size="large"
            onClick={onClickTerminate}
            style={{
              width: 191,
              alignSelf: "flex-end",
            }}
            disabled={false}
          >
            <span>Cancel</span>
          </MtiButton>
        ) : (
          <div style={{ height: 47 }}></div>
        )}
      </Modal.Body>
    </Modal>
  );
}
